import React, {useState} from "react";
import "./header.scss";
import Logo from "../../assets/ncpti-logo-blue.png";
import {
    FaTelegram,
    FaVk,
    FaYoutube,
    FaDoorClosed,
    FaDoorOpen,
    FaRegUserCircle,
    FaSignInAlt
} from "react-icons/fa";
import {Link} from "react-router-dom";
import {baseUrl} from "../../constants/constants";
import {useAuth} from "../authProvider/authProvider";

const Header = () => {
    const authContext = useAuth();
    const access = localStorage.getItem("access");

    const [ruHover, setState] = useState<boolean>(false);
    // const [yaHover, setYaHover] = useState<boolean>(false);

    const handleClick = () => {
        window.open('https://dzen.ru/ncpti', '_blank');
    };

    return (
        <div className="header">
            <div className='header-main'>
                <div className="header__logo">
                    <Link to="/" className="header__logo-link" title="На главную">
                        <img src={Logo} alt="Логотип НЦПТИ" className="header__logo-img"/>
                    </Link>
                </div>
                {/*<div className="header__center">*/}
                    {/*<search*/}
                    {/*    role="search"*/}
                    {/*    className='header__center-search'*/}
                    {/*>*/}
                    {/*    <input*/}
                    {/*        type="text"*/}
                    {/*        placeholder='Поиск...'*/}
                    {/*        className='header__center-input'*/}
                    {/*    />*/}
                    {/*</search>*/}

                {/*</div>*/}
                <section className="header__social-links">
                    <div className="header__social-links-blog">
                        <Link to="novosti">
                            <button className="button header__btn">Новости</button>
                        </Link>
                    </div>
                    {/*<div>*/}
                    {/*    <a href="https://ncpti.ru/umcz/" target='_blank'>*/}
                    {/*        <button className="button header__btn">Сеть центров</button>*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <a href="https://vk.com/ncpti_rnd" target="_blank" title="Наш ВК">
                            <FaVk className="social-icon"/>
                        </a>
                        <a href="https://t.me/ncpti" target="_blank" title="Наш телеграм">
                            <FaTelegram className="social-icon"/>
                        </a>
                        <a onClick={handleClick} title="Yandex Dzen" style={{cursor:'pointer'}}
                        >
                            <svg width="40" height="25" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                                 className={'social-icon_dzen'}
                            >
                                <path
                                    d="M14.3143 14.3143C12.4286 16.26 12.2914 18.6857 12.1286 24C17.0829 24 20.5029 23.9829 22.2686 22.2686C23.9829 20.5029 24 16.92 24 12.1286C18.6857 12.3 16.26 12.4286 14.3143 14.3143ZM0 12.1286C0 16.92 0.0171428 20.5029 1.73143 22.2686C3.49714 23.9829 6.91714 24 11.8714 24C11.7 18.6857 11.5714 16.26 9.68571 14.3143C7.74 12.4286 5.31429 12.2914 0 12.1286ZM11.8714 0C6.92571 0 3.49714 0.0171428 1.73143 1.73143C0.0171428 3.49714 0 7.08 0 11.8714C5.31429 11.7 7.74 11.5714 9.68571 9.68571C11.5714 7.74 11.7086 5.31429 11.8714 0ZM14.3143 9.68571C12.4286 7.74 12.2914 5.31429 12.1286 0C17.0829 0 20.5029 0.0171428 22.2686 1.73143C23.9829 3.49714 24 7.08 24 11.8714C18.6857 11.7 16.26 11.5714 14.3143 9.68571Z"
                                />
                            </svg>
                        </a>
                        <a
                            href="https://rutube.ru/channel/25826771/"
                            target="_blank"
                            title="Наш RuTube-канал"
                        >
                            <svg width="40" height="25" viewBox="0 0 25 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg" className={'social-icon'}
                                 onMouseEnter={() => setState(true)}
                                 onMouseLeave={() => setState(false)}
                            >
                                <g clipPath="url(#clip0_12_17218)">
                                    <path
                                        d="M15.3996 12.0699H8.17243V9.21004H15.3996C15.8218 9.21004 16.1153 9.28362 16.2626 9.41212C16.4099 9.54062 16.5012 9.77894 16.5012 10.1271V11.154C16.5012 11.5208 16.4099 11.7591 16.2626 11.8876C16.1153 12.0161 15.8218 12.071 15.3996 12.071V12.0699ZM15.8954 6.51379H5.10742V18.7441H8.17243V14.7651H13.8209L16.5012 18.7441H19.9334L16.9783 14.7464C18.0678 14.585 18.557 14.2511 18.9604 13.7009C19.3639 13.1506 19.5662 12.2709 19.5662 11.0969V10.1798C19.5662 9.48351 19.4925 8.93328 19.3639 8.51154C19.2353 8.08981 19.0154 7.72299 18.7032 7.39351C18.3734 7.0816 18.0062 6.86194 17.5653 6.71478C17.1245 6.58628 16.5737 6.5127 15.8954 6.5127V6.51379Z"
                                        fill={ruHover ? '#5856d6' : '#C1C2D1'}></path>
                                    <path
                                        d="M36.9843 0.396693C36.9843 7.15191 31.5081 12.6281 24.7529 12.6281C23.3795 12.6281 22.0589 12.4017 20.8265 11.9843C20.8529 11.6936 20.8645 11.3965 20.8645 11.0966V10.1795C20.8645 9.40085 20.7832 8.71448 20.6058 8.13279C20.4145 7.50551 20.0863 6.96566 19.6459 6.50089L19.6215 6.47509L19.5957 6.45067C19.1264 6.00685 18.5945 5.69001 17.9772 5.48396L17.9535 5.47603L17.9295 5.46903C17.3419 5.29778 16.6636 5.21512 15.8965 5.21512H14.5992V5.21622H13.5076C12.8729 3.73729 12.5215 2.10804 12.5215 0.396693C12.5215 -6.35853 17.9977 -11.8347 24.7529 -11.8347C31.5081 -11.8347 36.9843 -6.35853 36.9843 0.396693Z"
                                        fill={ruHover ? '#5856d6' : '#C1C2D1'}></path>
                                </g>
                                <rect x="0.474846" y="0.582512" width="24.0912" height="24.0912" rx="5.76463"
                                      stroke={ruHover ? '#5856d6' : '#C1C2D1'}
                                      strokeWidth="0.371567"></rect>
                                <defs>
                                    <clipPath id="clip0_12_17218">
                                        <rect x="0.289062" y="0.396729" width="24.4628" height="24.4628" rx="5.95041"
                                              fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                        {authContext?.authState.isAuth ? (
                            <>
                                <Link to="akkaunt" title="Личный кабинет">
                                    <FaRegUserCircle className="social-icon"/>
                                </Link>
                            </>
                        ) : (
                            <Link to="/login" title="Войти">
                                <FaSignInAlt className="social-icon"/>
                            </Link>
                        )}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Header;
